import { useRef } from "react";
import { AriaTextFieldProps, useTextField } from "react-aria";

import "./index.scss";

export const TextField = (props: AriaTextFieldProps & { className?: string }) => {
  const { label } = props;
  const ref = useRef(null);
  const { labelProps, inputProps, descriptionProps, errorMessageProps } = useTextField(props, ref);

  return (
    <div className={`TextField ${props.className || ""} ${props.isReadOnly ? "isReadonly" : ""}`}>
      <label {...labelProps}>{label}</label>
      <input {...inputProps} ref={ref} />
      {props.description && (
        <div {...descriptionProps} className="description">
          {props.description}
        </div>
      )}
      {props.errorMessage && (
        <div {...errorMessageProps} className="errorMessage">
          {props.errorMessage}
        </div>
      )}
    </div>
  );
};
